module.exports = __webpack_public_path__ + "media/images/official/top_about-73fee37d3a4294cbd74edbf76dee5c3e.webp";